import styled from 'styled-components';

import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import { TopTooltip } from 'ui/tooltip/Tooltip';
import { spacing, colors } from 'ui/theme';

export const NBA_AUDIENCE_AI_LIST_ID = 'nba-audience-section-ai-list';
export const AIListIcon = () => {
  const AiSparkleWrapper = styled.div`
    display: flex;
    align-items: center;
    border-radius: 50%;
    margin-left: ${spacing.quarter};
    background-color: ${colors.purple10};
    padding: ${spacing.eighth};
  `;
  return (
    <TopTooltip tooltipContent="Generated by Iterable AI">
      <AiSparkleWrapper data-test={NBA_AUDIENCE_AI_LIST_ID}>
        <AiSparkle16 />
      </AiSparkleWrapper>
    </TopTooltip>
  );
};

export const NBAListIndication = ({ name }: { name: string }) => {
  if (!name.startsWith('[AI Retargeting]')) {
    return null;
  }
  return <AIListIcon />;
};
